// pages/FormViewerPage/components/CustomerInfoFields/EmailField.tsx — Email field
import React from 'react';
import type { CustomerInfoFieldsProps } from './types';

export const EmailField: React.FC<CustomerInfoFieldsProps> = ({ form, customerData, fieldErrors, onCustomerDataChange }) => {
    if (!form.customerFields?.email?.visible) return null;
    return (
        <div>
            <label htmlFor="field-email" className="block text-sm font-medium mb-0.5 text-slate-700 dark:text-slate-300">Email {form.customerFields?.email?.required && <span className="text-red-500">*</span>}</label>
            <input
                id="field-email"
                type="email"
                name="email"
                value={customerData.email}
                onChange={onCustomerDataChange}
                placeholder="email@example.com"
                autoComplete="email"
                className="w-full p-2.5 border-2 border-slate-400 rounded-lg bg-slate-50 dark:bg-slate-700 dark:border-slate-500 focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all"
                required={form.customerFields?.email?.required}
            />
            {fieldErrors.email && <p className="text-xs text-red-500">{fieldErrors.email}</p>}
        </div>
    );
};
